import { render, staticRenderFns } from "./EditEducationalPost.vue?vue&type=template&id=01d113e9&"
import script from "./EditEducationalPost.vue?vue&type=script&lang=js&"
export * from "./EditEducationalPost.vue?vue&type=script&lang=js&"
import style0 from "./EditEducationalPost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports